import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=ca596454&scoped=true&"
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"
import style0 from "./approval.vue?vue&type=style&index=0&id=ca596454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca596454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca596454')) {
      api.createRecord('ca596454', component.options)
    } else {
      api.reload('ca596454', component.options)
    }
    module.hot.accept("./approval.vue?vue&type=template&id=ca596454&scoped=true&", function () {
      api.rerender('ca596454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/bill/remittance/approval/approval.vue"
export default component.exports